import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { outputInfoStoreToken } from '../../../../../../h3ml/state/output-info';
import { TaskWorkspaceStore } from '../../../../../../h3ml/state/task-workspace-store';
import { FocusableScrubberService } from '../focusable-scrubber.service';

export const ICON_CENTER_OFFSET = 12;

@Component({
  selector: 'h3-scrubber-cursor',
  templateUrl: './scrubber-cursor.component.html',
  styleUrls: ['./scrubber-cursor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ScrubberCursorComponent {
  left$: Observable<string>;
  private taskWorkspaceStore = inject(TaskWorkspaceStore);
  private outputInfoStore = inject(outputInfoStoreToken);

  constructor(focusableScrubberService: FocusableScrubberService) {
    const maxFrameNumber = this.taskWorkspaceStore.getMaxFrameNumber(
      this.outputInfoStore.state().output.name,
    );
    this.left$ = focusableScrubberService.frameNumber$.pipe(
      map(
        (frameNumber) =>
          `calc(${
            (frameNumber / maxFrameNumber) * 100
            // The icon is 24px wide, so we need to subtract 12px to
            // center it on the cursor.
          }% - ${ICON_CENTER_OFFSET}px)`,
      ),
    );
  }
}
